import { useTheme } from '@mui/material/styles';
import {
  Box,
  Grid,
  Divider, Container, Typography, Breadcrumbs
} from '@mui/material';
// import EventListSection from '../sections/_dashboard/EventListSection';
import {
  getlocalStorageUserObject,
} from "../../helper/LocalStorageHelper";
import { getStoredAccountOrgID } from "../../helper/AccountHelper.js";
import UserEventListSection from '../../sections/_dashboard/UserEventListSection';
import OrgMonthlyStatBarChart from "../../components/chart/OrgMonthlyStatBarChart";
import OrgStatDashboardData from "../../components/chart/OrgStatDashboardData";
import OrgSkillStatDashboardTable from "../../components/chart/OrgSkillStatDashboardTable";
import DatePeriodOption from "../../components/common/DatePeriodOption";
import { getCurrentPeriodYear } from "../../helper/DatePeriodHelper";

import React from 'react';

// ----------------------------------------------------------------------

export default function UserDashboardPage() {
  const [startYear, setStartYear] = React.useState(getCurrentPeriodYear());
  // const [user]
  const theme = useTheme();
  const user = getlocalStorageUserObject();
  let storedOrgID = getStoredAccountOrgID();

  let year = 2024;     // Use Option Bar 
  let orgId = storedOrgID;
  let startMonth = 9; // TODO: ken: use setting 


  // const userObj = JSON.parse(user);


  // console.debug("user=", user);
  // console.debug("userObj=", userObj);
  const username = user.username;
  // console.debug("username=", username);

  let handleYearChange = (year) => {
    setStartYear(year);
  }

  return (
    <>
      <title> Dashboard </title>


      <Container maxWidth="xl">
        {/* <Breadcrumbs aria-label="breadcrumb">
          <Typography color="text.primary">User Dashboard</Typography>
        </Breadcrumbs> */}

        {/* <Typography variant="h4" sx={{ mb: 5 }}>
          Welcome back, {username}
        </Typography> */}
        <Grid container spacing={2} sx={{ mb: 2, justifyContent: 'flex-end' }}>
          <Grid item xs={12} md={4}>
            {/* <pre>orgId: *{orgId}*</pre> */}
            {/* <pre>Start Year: {startYear}  </pre> */}
            <DatePeriodOption value={startYear} onChange={handleYearChange} />
            {/* <OrgStatDashboardData orgId={orgId} year={startYear} startMonth={startMonth} /> */}
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12}>
            {/* <pre>OrgID: {orgId}   </pre> */}
            <OrgStatDashboardData orgId={orgId} year={startYear} startMonth={startMonth} />
          </Grid>
        </Grid>



        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} md={6} >
            <Box sx={{ p: 0 }} >
              <OrgMonthlyStatBarChart mode="participant" orgId={orgId} year={startYear} startMonth={startMonth} />
            </Box>
          </Grid>
          <Grid item xs={12} md={6} >
            <Box sx={{ p: 0 }} >
              <OrgMonthlyStatBarChart mode="play_duration" orgId={orgId} year={startYear} startMonth={startMonth} />
            </Box>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12}>
            <OrgSkillStatDashboardTable orgId={orgId} year={startYear} startMonth={startMonth} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
